import React from "react";
import "./ArticleSection.scss";

/**
 *
 * @param {Object} props
 * @param {string} [props.sectionLabel]
 * @param {string} [props.title]
 * @param {{subtitle?: string, paragraphs?: string[]}[]} [props.sections]
 */
const ArticleSection = ({ sectionLabel = "", title = "", sections = [] }) => (
  <section className="ArticleSection">
    {sectionLabel && (
      <span className="ArticleSection-label">{sectionLabel}</span>
    )}

    <div className="ArticleSection-body">
      {title && <h3 className="ArticleSection-title">{title}</h3>}

      {sections.map((section, index) => (
        <div className="ArticleSection-block" key={index}>
          {section.subtitle && (
            <p className="ArticleSection-subtitle">{section.subtitle}</p>
          )}

          {section.paragraphs?.map((paragraph, pIndex) => (
            <p className="ArticleSection-paragraph" key={pIndex}>
              {paragraph}
            </p>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default ArticleSection;
